import React, { useContext } from 'react'
import styled from '@emotion/styled'
import Media from 'react-media'

import { AdsenseContext } from '../AdsenseProvider'

const AdContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 1rem;
	min-height: 50px;

	* {
		text-align: center;
	}

	${({ theme }) => theme.MQ.M} {
		min-height: 90px;
	}
`

// Optional Ad Leaderboard spot
export function Advertisement({ isHubTemplate }) {
	const { adsenseMediaQuery, hasAdsense } = useContext(AdsenseContext)

	if (!hasAdsense || isHubTemplate) {
		return null
	}

	return (
		<Media query={adsenseMediaQuery} defaultMatches={false}>
			{(matches) => matches && <AdContainer id="ad_leaderboard" />}
		</Media>
	)
}
